function displayCartCount(cart) {
  return cart.items.reduce(function (sum, item) {
    var realQuantity = item.properties && item.properties['Quantity'];
    return sum + (realQuantity ? Number(realQuantity) : item.quantity);
  }, 0);
}

function refreshCartDrawer() {
  fetch('/?section_id=cart-drawer-section')
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-contents]');
      var current = document.querySelector('[data-cart-drawer-contents]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    });
}

document.addEventListener('click', function (e) {
  var removeButton = e.target.closest('[data-cart-remove]');
  if (!removeButton) return;
  e.preventDefault();
  removeButton.disabled = true;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: removeButton.dataset.lineKey, quantity: 0 })
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = displayCartCount(cart);
      });
      if (window.location.pathname.indexOf('/cart') === 0) {
        window.location.reload();
      } else {
        refreshCartDrawer();
      }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('cart-drawer');
  var lastCartOpener = null;
  function openCartDrawer() {
    drawer.hidden = false;
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Shopping cart');
    var firstFocusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
    drawer.addEventListener('keydown', trapFocusInDrawer);
  }
  function closeCartDrawer() {
    drawer.hidden = true;
    drawer.removeEventListener('keydown', trapFocusInDrawer);
    if (lastCartOpener) lastCartOpener.focus();
  }
  function trapFocusInDrawer(e) {
    if (e.key !== 'Tab') {
      if (e.key === 'Escape') closeCartDrawer();
      return;
    }
    var focusable = Array.from(drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function(el) { return !el.disabled; });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      lastCartOpener = el;
      openCartDrawer();
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeCartDrawer();
    });
  }

  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', function () {
      menu.hidden = false;
      menuToggle.setAttribute('aria-expanded', 'true');
      var firstLink = menu.querySelector('a, button');
      if (firstLink) firstLink.focus();
    });
  }
  if (menuClose && menu) {
    menuClose.addEventListener('click', function () {
      menu.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.focus();
    });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var isHidden = searchPanel.hidden;
      searchPanel.hidden = !isHidden;
      searchToggle.setAttribute('aria-expanded', String(isHidden));
      if (isHidden) searchPanel.querySelector('input').focus();
    });
  }

  document.querySelectorAll('#ProductForm').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitButton = form.querySelector('[data-add-to-cart]');
      var originalLabel = submitButton.textContent;
      var rushCheckbox = form.querySelector('#RushOrder');
      var rushFeeVariantId = rushCheckbox ? rushCheckbox.dataset.rushFeeVariantId : '';

      if (form.querySelector('[data-quantity-tier-mode]')) {
        var tierPicker = document.querySelector('quantity-tier-picker');
        if (tierPicker && tierPicker.submitTierOrder) {
          tierPicker.submitTierOrder(form, submitButton, originalLabel, rushCheckbox, rushFeeVariantId);
        }
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            submitButton.disabled = false;
            submitButton.textContent = originalLabel;
            alert(data.description || 'Something went wrong adding this to your cart.');
            return Promise.reject(data);
          }

          if (rushCheckbox && rushCheckbox.checked && rushFeeVariantId) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: rushFeeVariantId, quantity: 1 })
            });
          }
        })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = displayCartCount(cart);
          });
          refreshCartDrawer();
          document.getElementById('cart-drawer').hidden = false;
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        })
        .catch(function () {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        });
    });
  });

  var galleryMain = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (galleryMain) galleryMain.src = thumb.getAttribute('data-full');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  var descriptionEl = document.querySelector('[data-product-description]');
  if (descriptionEl) {
    var allChildren = Array.from(descriptionEl.children);
    if (allChildren.length > 2) {
      var firstPara = allChildren[1] || allChildren[0];
      var rest = allChildren.slice(2);
      rest.forEach(function (el) { el.hidden = true; });

      var toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'description-inline-toggle';
      toggleBtn.textContent = ' Read More';
      toggleBtn.addEventListener('click', function () {
        var expanding = rest[0].hidden;
        rest.forEach(function (el) { el.hidden = !expanding; });
        toggleBtn.textContent = expanding ? ' Read Less' : ' Read More';
      });
      firstPara.appendChild(toggleBtn);
    }
  }

  var stickyBuyBar = document.querySelector('[data-sticky-buy-bar]');
  var mainAddToCartButton = document.querySelector('[data-add-to-cart]');
  if (stickyBuyBar && mainAddToCartButton) {
    var stickyButton = stickyBuyBar.querySelector('[data-sticky-buy-button]');
    var stickyPrice = stickyBuyBar.querySelector('[data-sticky-price]');
    var mainPriceDisplay = document.querySelector('[data-price-display]');

    stickyButton.addEventListener('click', function () {
      mainAddToCartButton.click();
    });

    if (mainPriceDisplay) {
      var priceObserver = new MutationObserver(function () {
        stickyPrice.textContent = mainPriceDisplay.textContent;
      });
      priceObserver.observe(mainPriceDisplay, { childList: true, characterData: true, subtree: true });
    }

    var observer = new IntersectionObserver(function (entries) {
      stickyBuyBar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '-120px 0px 0px 0px' });
    observer.observe(mainAddToCartButton);
  }

  var purchaseTabs = document.querySelectorAll('[data-purchase-tab]');
  if (purchaseTabs.length > 0) {
    purchaseTabs.forEach(function (tab) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', tab.classList.contains('is-active') ? 'true' : 'false');
      var panelId = 'purchase-panel-' + tab.dataset.purchaseTab;
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('id', 'purchase-tab-' + tab.dataset.purchaseTab);
    });
    document.querySelectorAll('[data-purchase-panel]').forEach(function (panel) {
      var panelId = 'purchase-panel-' + panel.dataset.purchasePanel;
      panel.setAttribute('id', panelId);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', 'purchase-tab-' + panel.dataset.purchasePanel);
    });
    purchaseTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.purchaseTab;
        purchaseTabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        document.querySelectorAll('[data-purchase-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.purchasePanel !== target;
        });
      });
    });
  }

  document.querySelectorAll('[data-faq-toggle]').forEach(function (button, i) {
    var item = button.closest('[data-faq-item]');
    var answer = item.querySelector('.faq-item__answer');
    var answerId = 'faq-answer-' + i;
    if (answer) {
      answer.setAttribute('id', answerId);
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-labelledby', 'faq-btn-' + i);
    }
    button.setAttribute('id', 'faq-btn-' + i);
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', answerId);
    button.addEventListener('click', function () {
      var isOpen = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  var lightbox = document.getElementById('GalleryLightbox');
  var lightboxImage = document.getElementById('GalleryLightboxImage');
  document.querySelectorAll('[data-gallery-item]').forEach(function (img) {
    img.addEventListener('click', function () {
      lightboxImage.src = img.getAttribute('data-full');
      lightboxImage.alt = img.alt;
      lightbox.hidden = false;
    });
  });
  document.querySelectorAll('[data-gallery-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      lightbox.hidden = true;
    });
  });
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) lightbox.hidden = true;
    });
  }
});

class CarouselComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = Array.from(this.querySelectorAll('.carousel__slide'));
    this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
    this.index = 0;
    this.base = 0;

    if (this.slides.length > 1 && !this.track.querySelector('[data-carousel-clone]')) {
      var firstClone = this.slides[0].cloneNode(true);
      var lastClone = this.slides[this.slides.length - 1].cloneNode(true);
      [firstClone, lastClone].forEach(function (clone) {
        clone.setAttribute('data-carousel-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      });
      this.track.insertBefore(lastClone, this.slides[0]);
      this.track.appendChild(firstClone);
      this.base = 1;
    }
    this.pos = this.base;

    var prev = this.querySelector('[data-carousel-prev]');
    var next = this.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', this.go.bind(this, -1));
    if (next) next.addEventListener('click', this.go.bind(this, 1));
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        this.snapFromClone();
        this.index = i;
        this.pos = i + this.base;
        this.update(true);
      }.bind(this));
    }.bind(this));

    this.track.addEventListener('click', function (e) {
      var slide = e.target.closest('.carousel__slide');
      if (!slide) return;
      var target = Array.prototype.indexOf.call(this.track.children, slide);
      if (target === this.pos) return;
      e.preventDefault();
      this.go(target - this.pos);
    }.bind(this));

    this.track.addEventListener('transitionend', function (e) {
      if (e.target === this.track) this.snapFromClone();
    }.bind(this));
    window.addEventListener('resize', function () { this.update(false); }.bind(this));

    this.liveRegion = document.createElement('div');
    this.liveRegion.setAttribute('aria-live', 'polite');
    this.liveRegion.setAttribute('aria-atomic', 'true');
    this.liveRegion.className = 'visually-hidden';
    this.appendChild(this.liveRegion);

    this.update(false);
    this.startAutoplay();

    this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
    this.addEventListener('mouseleave', this.startAutoplay.bind(this));

    var touchStartX = 0;
    this.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    this.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) this.go(diff > 0 ? 1 : -1);
    }.bind(this), { passive: true });
  }

  startAutoplay() {
    this.stopAutoplay();
    this._autoplay = setInterval(this.go.bind(this, 1), 6000);
  }

  stopAutoplay() {
    clearInterval(this._autoplay);
  }

  go(direction) {
    if (this.slides.length < 2) return;
    this.snapFromClone();
    this.pos += direction;
    this.index = (this.index + direction + this.slides.length) % this.slides.length;
    this.update(true);
  }

  // After sliding onto a looping clone, jump (without animating) to the matching real slide.
  snapFromClone() {
    var count = this.slides.length;
    if (count < 2) return;
    if (this.pos <= 0) this.pos = count;
    else if (this.pos >= count + 1) this.pos = 1;
    else return;
    this.setTrackPosition(false);
    this.markCurrent();
  }

  setTrackPosition(animate) {
    var first = this.track.children[0].getBoundingClientRect();
    var second = this.track.children[1];
    var stride = second ? second.getBoundingClientRect().left - first.left : first.width;
    var x = (this.clientWidth - first.width) / 2 - this.pos * stride;
    if (!animate) this.track.style.transition = 'none';
    this.track.style.transform = 'translateX(' + x + 'px)';
    if (!animate) {
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }
  }

  markCurrent() {
    Array.prototype.forEach.call(this.track.children, function (slide, i) {
      slide.classList.toggle('is-current', i === this.pos);
    }.bind(this));
    this.classList.add('is-ready');
  }

  update(animate) {
    this.setTrackPosition(animate !== false);
    this.markCurrent();
    this.dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    }.bind(this));
    if (this.liveRegion) {
      this.liveRegion.textContent = 'Slide ' + (this.index + 1) + ' of ' + this.slides.length;
    }
  }
}

customElements.define('carousel-component', CarouselComponent);

class ProductVariantPicker extends HTMLElement {
  connectedCallback() {
    this.variantMap = {};
    try {
      var variantScript = this.querySelector('[data-variant-map]');
      this.variantMap = JSON.parse(variantScript.textContent.trim() || '{}');
    } catch (e) {
      this.variantMap = {};
    }

    this.qtyOptionIndex = Number(this.dataset.qtyOptionIndex);
    this.unitLabel = this.dataset.unitLabel || 'sticker';

    this.priceDisplay = this.querySelector('[data-price-display]');
    this.priceNote = this.querySelector('[data-price-note]');
    this.priceSavings = this.querySelector('[data-price-savings]');
    this.addToCartButton = this.querySelector('[data-add-to-cart]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.selectors = Array.from(this.querySelectorAll('[data-option-selector]'));

    this.selectors.forEach(function (select) {
      select.addEventListener('change', this.handleChange.bind(this));
    }.bind(this));

    this.handleChange();
  }

  findNextTier(values, currentVariant) {
    if (this.qtyOptionIndex < 0 || isNaN(this.qtyOptionIndex)) return null;

    var currentQty = parseFloat(currentVariant.options[this.qtyOptionIndex]);
    if (isNaN(currentQty)) return null;

    var candidates = [];
    Object.keys(this.variantMap).forEach(function (key) {
      var candidate = this.variantMap[key];
      var matchesOtherOptions = candidate.options.every(function (optionValue, i) {
        return i === this.qtyOptionIndex || optionValue === values[i];
      }.bind(this));
      if (!matchesOtherOptions) return;

      var qty = parseFloat(candidate.options[this.qtyOptionIndex]);
      if (!isNaN(qty) && qty > currentQty) candidates.push({ qty: qty, variant: candidate });
    }.bind(this));

    if (candidates.length === 0) return null;
    candidates.sort(function (a, b) { return a.qty - b.qty; });
    return candidates[0];
  }

  handleChange() {
    var values = this.selectors.map(function (s) { return s.value; });
    var key = values.join(' / ');
    var variant = this.variantMap[key];

    if (!variant && this.selectors.length === 0) {
      var onlyKey = Object.keys(this.variantMap)[0];
      variant = this.variantMap[onlyKey];
    }

    if (!variant) return;

    if (this.variantInput) this.variantInput.value = variant.id;
    this.priceDisplay.textContent = '$' + Number(variant.price / 100).toFixed(2);
    if (this.priceNote) this.priceNote.hidden = true;

    this.addToCartButton.disabled = !variant.available;
    this.addToCartButton.textContent = variant.available ? this.addToCartButton.dataset.addLabel : this.addToCartButton.dataset.soldOutLabel;

    if (this.priceSavings) {
      var next = this.findNextTier(values, variant);
      if (next && next.variant.available) {
        var currentQty = parseFloat(variant.options[this.qtyOptionIndex]);
        var perUnitNow = variant.price / currentQty;
        var perUnitNext = next.variant.price / next.qty;
        var savingsPct = Math.round(((perUnitNow - perUnitNext) / perUnitNow) * 100);
        if (savingsPct > 0) {
          this.priceSavings.textContent = 'Order ' + next.qty + ' to save ' + savingsPct + '% per ' + this.unitLabel + ' ($' + (perUnitNext / 100).toFixed(2) + ' vs $' + (perUnitNow / 100).toFixed(2) + ')';
          this.priceSavings.hidden = false;
        } else {
          this.priceSavings.hidden = true;
        }
      } else {
        this.priceSavings.hidden = true;
      }
    }
  }
}

customElements.define('product-variant-picker', ProductVariantPicker);

/* Per-inch-per-unit rate at each quantity tier (keyed by the larger of width/height,
   not raw area — die-cut sticker pricing scales close to linearly with size, not
   quadratically). Derived from real 2in/4in die-cut sticker variant pricing. */
var CALC_RATE_TIERS = [
  [50, 0.395],
  [100, 0.321238],
  [200, 0.209844],
  [300, 0.185583],
  [500, 0.149],
  [1000, 0.112],
  [2000, 0.0926875],
  [3000, 0.085667]
];

function qtyDiscountForCount(quantity) {
  if (quantity >= 26) return 0.20;
  if (quantity >= 11) return 0.15;
  if (quantity >= 6) return 0.10;
  if (quantity >= 2) return 0.05;
  return 0;
}

function calcRateForQuantity(quantity) {
  if (quantity <= CALC_RATE_TIERS[0][0]) return CALC_RATE_TIERS[0][1];
  var last = CALC_RATE_TIERS[CALC_RATE_TIERS.length - 1];
  if (quantity >= last[0]) return last[1];

  for (var i = 0; i < CALC_RATE_TIERS.length - 1; i++) {
    var lo = CALC_RATE_TIERS[i];
    var hi = CALC_RATE_TIERS[i + 1];
    if (quantity >= lo[0] && quantity <= hi[0]) {
      var ratio = (quantity - lo[0]) / (hi[0] - lo[0]);
      return lo[1] + (hi[1] - lo[1]) * ratio;
    }
  }
  return last[1];
}

class CustomCalculator extends HTMLElement {
  connectedCallback() {
    this.rateMultiplier = Number(this.dataset.rateMultiplier) || 1;
    this.baseFee = Number(this.dataset.baseFee) || 0;
    this.minOrder = Number(this.dataset.minOrder) || 0;
    this.productTitle = this.dataset.productTitle || '';
    this.hasPriceTable = this.dataset.hasPriceTable === 'true';
    this.sqftPricing = this.dataset.sqftPricing === 'true';
    this.areaPricing = this.dataset.areaPricing === 'true';
    this.smallSizeRamp = this.dataset.smallSizeRamp === 'true';
    this.geomeanPricing = this.dataset.geomeanPricing === 'true';
    this.requestQuoteOnly = this.dataset.requestQuoteOnly === 'true';
    this.quotePageHandle = this.dataset.quotePageHandle || '';

    this.widthInput = this.querySelector('[data-calc-width]');
    this.heightInput = this.querySelector('[data-calc-height]');
    [this.widthInput, this.heightInput].forEach(function (el) {
      if (!el) return;
      el.addEventListener('blur', function () {
        var min = Number(el.min);
        var max = Number(el.max);
        var value = Number(el.value) || min;
        if (value < min) el.value = min;
        if (value > max) el.value = max;
      });
    });
    this.quantityInput = this.querySelector('[data-calc-quantity]');
    this.priceDisplay = this.querySelector('[data-calc-price]');
    this.savingsDisplay = this.querySelector('[data-calc-savings]');
    this.perUnitDisplay = this.querySelector('[data-calc-per-unit]');
    this.artworkInput = this.querySelector('[data-calc-artwork]');
    this.rushCheckbox = this.querySelector('[data-calc-rush]');
    this.finishSelect = this.querySelector('[data-calc-finish]');
    this.shapeSelect = this.querySelector('[data-calc-shape]');
    this.cutTypeSelect = this.querySelector('[data-calc-cut-type]');
    this.addToCartButton = this.querySelector('[data-calc-add-to-cart]');
    this.requestQuoteLink = this.querySelector('[data-calc-request-quote]');
    this.orderVariantId = this.dataset.orderVariantId;
    this.rushFeeVariantId = this.dataset.rushFeeVariantId;

    if (this.hasPriceTable) {
      this.priceTable = this.parsePriceTable();
      this.sizeKeys = Object.keys(this.priceTable)
        .map(Number)
        .sort(function (a, b) { return a - b; });
    }

    if (this.sqftPricing) {
      this.sqftTiers = this.parseSqftTierTable();
    }
    if (this.areaPricing) {
      this.areaTiers = this.parseAreaTierTable();
    }

    var inputs = [this.widthInput, this.heightInput, this.quantityInput, this.cutTypeSelect].filter(Boolean);
    inputs.forEach(function (el) {
      el.addEventListener('input', this.update.bind(this));
      el.addEventListener('change', this.update.bind(this));
    }.bind(this));

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.addToCart.bind(this));
    }

    this.update();
  }

  addToCart() {
    if (!this.orderVariantId) return;
    var originalLabel = this.addToCartButton.textContent;
    this.addToCartButton.disabled = true;
    this.addToCartButton.textContent = 'Adding…';

    var width = Number(this.widthInput.value) || 0;
    var height = Number(this.heightInput.value) || 0;
    var quantity = Number(this.quantityInput.value) || 0;
    var total = Number(this.priceDisplay.textContent.replace('$', '')) || 0;
    var dollars = Math.ceil(total);

    var formData = new FormData();
    formData.append('id', this.orderVariantId);
    formData.append('quantity', dollars);
    formData.append('properties[Product]', this.productTitle);
    formData.append('properties[_product_url]', window.location.pathname);
    formData.append('properties[Size]', width + 'in x ' + height + 'in');
    formData.append('properties[Quantity]', quantity);
    formData.append('properties[Calculated Price]', '$' + dollars.toFixed(2));
    if (this.finishSelect) {
      formData.append('properties[Finish]', this.finishSelect.value);
    }
    if (this.shapeSelect) {
      formData.append('properties[Shape]', this.shapeSelect.value);
    }
    if (this.cutTypeSelect) {
      formData.append('properties[Cut Type]', this.cutTypeSelect.value);
    }
    if (this.rushCheckbox && this.rushCheckbox.checked) {
      formData.append('properties[Rush Order]', 'Yes');
    }
    if (this.artworkInput && this.artworkInput.files[0]) {
      formData.append('properties[Artwork]', this.artworkInput.files[0]);
    }
    var outlineFlag = this.querySelector('[data-outline-flag]');
    if (outlineFlag && outlineFlag.value) {
      formData.append('properties[Outline Approval]', outlineFlag.value);
    }

    var self = this;
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          self.addToCartButton.disabled = false;
          self.addToCartButton.textContent = originalLabel;
          alert(data.description || 'Something went wrong adding this to your cart.');
          return Promise.reject(data);
        }
        if (self.rushCheckbox && self.rushCheckbox.checked && self.rushFeeVariantId) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: self.rushFeeVariantId, quantity: 1 })
          });
        }
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = displayCartCount(cart);
        });
        refreshCartDrawer();
        document.getElementById('cart-drawer').hidden = false;
        self.addToCartButton.disabled = false;
        self.addToCartButton.textContent = originalLabel;
      })
      .catch(function () {
        self.addToCartButton.disabled = false;
        self.addToCartButton.textContent = originalLabel;
      });
  }

  parsePriceTable() {
    var table = {};
    try {
      var script = this.querySelector('[data-price-table]');
      var raw = JSON.parse(script.textContent.trim() || '{}');
      Object.keys(raw).forEach(function (key) {
        var parts = key.split('|');
        var sizeKey = String(parseFloat(parts[0]));
        var qty = parseFloat(parts[1]);
        if (!table[sizeKey]) table[sizeKey] = [];
        table[sizeKey].push([qty, raw[key] / 100]);
      });
      Object.keys(table).forEach(function (sizeKey) {
        table[sizeKey].sort(function (a, b) { return a[0] - b[0]; });
      });
    } catch (e) {
      table = {};
    }
    return table;
  }

  parseSqftTierTable() {
    try {
      var script = this.querySelector('[data-sqft-tier-table]');
      var raw = JSON.parse(script.textContent.trim() || '[]');
      return raw.sort(function (a, b) { return a[0] - b[0]; });
    } catch (e) {
      return [];
    }
  }

  parseAreaTierTable() {
    try {
      var script = this.querySelector('[data-area-tier-table]');
      var raw = JSON.parse(script.textContent.trim() || '[]');
      return raw.sort(function (a, b) { return a[0] - b[0]; });
    } catch (e) {
      return [];
    }
  }

  areaRateForSqIn(areaSqIn) {
    if (!this.areaTiers || this.areaTiers.length === 0) return 0;
    for (var i = 0; i < this.areaTiers.length; i++) {
      if (areaSqIn <= this.areaTiers[i][0]) return this.areaTiers[i][1];
    }
    return this.areaTiers[this.areaTiers.length - 1][1];
  }

  sqftRateForArea(area) {
    if (!this.sqftTiers || this.sqftTiers.length === 0) return 0;
    for (var i = 0; i < this.sqftTiers.length; i++) {
      if (area <= this.sqftTiers[i][0]) return this.sqftTiers[i][1];
    }
    return this.sqftTiers[this.sqftTiers.length - 1][1];
  }

  priceAtSizeForQuantity(sizeKey, quantity) {
    var tiers = this.priceTable[String(sizeKey)];
    if (!tiers || tiers.length === 0) return null;
    if (tiers.length === 1) return tiers[0][1];

    if (quantity <= tiers[0][0]) {
      return tiers[0][1] * (quantity / tiers[0][0]);
    }
    var last = tiers[tiers.length - 1];
    if (quantity >= last[0]) {
      var secondLast = tiers[tiers.length - 2];
      var slope = (last[1] - secondLast[1]) / (last[0] - secondLast[0]);
      return last[1] + slope * (quantity - last[0]);
    }
    for (var i = 0; i < tiers.length - 1; i++) {
      var lo = tiers[i];
      var hi = tiers[i + 1];
      if (quantity >= lo[0] && quantity <= hi[0]) {
        var ratio = (quantity - lo[0]) / (hi[0] - lo[0]);
        return lo[1] + (hi[1] - lo[1]) * ratio;
      }
    }
    return last[1];
  }

  priceFromTable(size, quantity) {
    var keys = this.sizeKeys;
    if (!keys || keys.length === 0) return null;

    if (keys.length === 1) {
      return this.priceAtSizeForQuantity(keys[0], quantity);
    }
    if (size <= keys[0]) {
      var priceAtMin = this.priceAtSizeForQuantity(keys[0], quantity);
      return priceAtMin * (size / keys[0]);
    }
    var lastKey = keys[keys.length - 1];
    if (size >= lastKey) {
      var secondLastKey = keys[keys.length - 2];
      var priceAtLast = this.priceAtSizeForQuantity(lastKey, quantity);
      var priceAtSecondLast = this.priceAtSizeForQuantity(secondLastKey, quantity);
      var slope = (priceAtLast - priceAtSecondLast) / (lastKey - secondLastKey);
      return priceAtLast + slope * (size - lastKey);
    }
    for (var i = 0; i < keys.length - 1; i++) {
      var lo = keys[i];
      var hi = keys[i + 1];
      if (size >= lo && size <= hi) {
        var priceLo = this.priceAtSizeForQuantity(lo, quantity);
        var priceHi = this.priceAtSizeForQuantity(hi, quantity);
        var ratio = (size - lo) / (hi - lo);
        return priceLo + (priceHi - priceLo) * ratio;
      }
    }
    return this.priceAtSizeForQuantity(lastKey, quantity);
  }

  nearestSizeKey(size) {
    var keys = this.sizeKeys;
    var nearest = keys[0];
    var smallestDiff = Math.abs(size - keys[0]);
    keys.forEach(function (key) {
      var diff = Math.abs(size - key);
      if (diff < smallestDiff) {
        smallestDiff = diff;
        nearest = key;
      }
    });
    return nearest;
  }

  nextTierSavings(size, quantity) {
    var nearestKey = this.nearestSizeKey(size);
    var tiers = this.priceTable[String(nearestKey)];
    if (!tiers) return null;

    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i][0] > quantity) {
        next = tiers[i];
        break;
      }
    }
    if (!next) return null;

    var currentPrice = this.priceAtSizeForQuantity(nearestKey, quantity);
    var perUnitNow = currentPrice / quantity;
    var perUnitNext = next[1] / next[0];
    var savingsPct = Math.round(((perUnitNow - perUnitNext) / perUnitNow) * 100);
    if (savingsPct <= 0) return null;

    return { qty: next[0], savingsPct: savingsPct, perUnitNow: perUnitNow, perUnitNext: perUnitNext };
  }

  update() {
    var quantity = Number(this.quantityInput.value) || 0;
    var width = Number(this.widthInput.value) || 0;
    var height = Number(this.heightInput.value) || 0;
    var size;
    if (this.geomeanPricing) {
      var geomean = Math.sqrt(width * height);
      var isSquare = Math.abs(width - height) < 0.001;
      size = isSquare ? geomean : geomean * 1.04;
    } else {
      size = Math.max(width, height);
    }
    var total;
    var needsCustomQuote = (this.sqftPricing || this.areaPricing) && quantity > 200;

    if (needsCustomQuote) {
      total = 0;
    } else if (this.areaPricing) {
      var areaSqIn = width * height;
      var clampedQty = Math.max(quantity, 1);
      var areaRate = this.areaRateForSqIn(areaSqIn) * this.rateMultiplier;
      var perUnitBase = Math.max(areaSqIn * areaRate, this.minOrder / clampedQty);
      var discountPct = qtyDiscountForCount(clampedQty);
      var perUnitPrice = perUnitBase * (1 - discountPct);
      total = (perUnitPrice * clampedQty) + this.baseFee;
      if (total < this.minOrder) total = this.minOrder;
    } else if (this.sqftPricing) {
      var areaSqft = (width * height) / 144;
      var clampedQty = Math.max(quantity, 1);
      var effectiveBase;

      if (this.smallSizeRamp && areaSqft <= 5) {
        var minSizeIn = Number(this.widthInput.min) || 0;
        var refArea = (minSizeIn * minSizeIn) / 144;
        var boundaryRate = this.sqftRateForArea(5) * this.rateMultiplier;
        var boundaryPrice = 5 * boundaryRate;
        if (areaSqft <= refArea || boundaryPrice <= this.minOrder) {
          effectiveBase = this.minOrder;
        } else {
          var slope = (boundaryPrice - this.minOrder) / (5 - refArea);
          effectiveBase = this.minOrder + (areaSqft - refArea) * slope;
        }
      } else {
        var sqftRate = this.sqftRateForArea(areaSqft) * this.rateMultiplier;
        var perUnitBase = areaSqft * sqftRate;
        effectiveBase = Math.max(perUnitBase, this.minOrder);
      }

      var discountPct = qtyDiscountForCount(clampedQty);
      var perUnitPrice = effectiveBase * (1 - discountPct);
      total = (perUnitPrice * clampedQty) + this.baseFee;
    } else if (this.hasPriceTable) {
      var tablePrice = this.priceFromTable(size, quantity);
      total = (tablePrice !== null ? tablePrice * this.rateMultiplier : 0) + this.baseFee;
      if (!needsCustomQuote && total < this.minOrder) total = this.minOrder;
    } else {
      var rate = calcRateForQuantity(quantity) * this.rateMultiplier;
      total = (size * quantity * rate) + this.baseFee;
      if (!needsCustomQuote && total < this.minOrder) total = this.minOrder;
    }

    if (needsCustomQuote) {
      this.priceDisplay.textContent = 'Custom quote required';
    } else {
      this.priceDisplay.textContent = '$' + total.toFixed(2);
    }

    if (this.savingsDisplay) {
      var savings = this.hasPriceTable && quantity > 0 ? this.nextTierSavings(size, quantity) : null;
      if (savings) {
        this.savingsDisplay.textContent = 'Order ' + savings.qty + ' to save ' + savings.savingsPct + '% per sticker ($' + savings.perUnitNext.toFixed(2) + ' vs $' + savings.perUnitNow.toFixed(2) + ')';
        this.savingsDisplay.hidden = false;
      } else {
        this.savingsDisplay.hidden = true;
      }
    }

    if (this.perUnitDisplay) {
      if (needsCustomQuote) {
        this.perUnitDisplay.textContent = 'Orders of 201+ decals require a custom quote';
        this.perUnitDisplay.hidden = false;
      } else if (this.sqftPricing && quantity > 0) {
        var perUnit = total / quantity;
        this.perUnitDisplay.textContent = '$' + perUnit.toFixed(2) + ' per decal';
        this.perUnitDisplay.hidden = false;
      } else {
        this.perUnitDisplay.hidden = true;
      }
    }

    if (this.requestQuoteOnly && this.requestQuoteLink) {
      var params = new URLSearchParams();
      var bannerTitles = ['Custom Vinyl Banners', 'Banners'];
      params.set('product_type', bannerTitles.indexOf(this.productTitle) !== -1 ? 'Banners' : this.productTitle);
      params.set('size', width + 'in x ' + height + 'in');
      params.set('quantity', String(quantity));
      if (!needsCustomQuote) params.set('estimate', total.toFixed(2));
      if (this.cutTypeSelect) params.set('cut_type', this.cutTypeSelect.value);
      this.requestQuoteLink.href = '/pages/' + this.quotePageHandle + '?' + params.toString();
    }
  }
}

customElements.define('custom-calculator', CustomCalculator);

document.addEventListener('DOMContentLoaded', function () {
  var quoteForm = document.getElementById('QuoteForm');
  if (!quoteForm) return;

  var params = new URLSearchParams(window.location.search);
  var fieldMap = {
    product_type: 'QuoteProductType',
    size: 'QuoteSize',
    quantity: 'QuoteQuantity'
  };

  Object.keys(fieldMap).forEach(function (param) {
    var value = params.get(param);
    if (!value) return;
    var field = document.getElementById(fieldMap[param]);
    if (!field) return;
    if (field.tagName === 'SELECT') {
      Array.from(field.options).forEach(function (opt) {
        if (opt.value === value) opt.selected = true;
      });
    } else {
      field.value = value;
    }
  });

  var estimate = params.get('estimate');
  if (estimate) {
    var estimateField = document.getElementById('QuoteEstimate');
    if (estimateField) estimateField.value = '$' + parseFloat(estimate).toFixed(2);
  }

  var cutType = params.get('cut_type');
  if (cutType) {
    var notes = document.getElementById('QuoteNotes');
    if (notes) {
      notes.value = 'Cut Type: ' + cutType + (notes.value ? '\n' + notes.value : '');
    }
  }
});

class QuantityTierPicker extends HTMLElement {
  connectedCallback() {
    this.orderVariantId = this.dataset.orderVariantId;
    this.productTitle = this.dataset.productTitle || '';

    this.table = this.parseTierTable();
    this.optionSelectors = Array.from(this.querySelectorAll('[data-option-selector]'));
    this.quantityInput = this.querySelector('[data-tier-quantity]');
    this.priceDisplay = document.querySelector('[data-price-display]');
    this.priceNote = document.querySelector('[data-price-note]');
    this.priceSavings = document.querySelector('[data-price-savings]');
    this.unitLabel = this.dataset.unitLabel || 'sticker';

    var inputs = this.optionSelectors.concat([this.quantityInput]);
    inputs.forEach(function (el) {
      el.addEventListener('input', this.update.bind(this));
      el.addEventListener('change', this.update.bind(this));
    }.bind(this));

    this.update();
  }

  parseTierTable() {
    var table = {};
    try {
      var script = this.querySelector('[data-tier-table]');
      var raw = JSON.parse(script.textContent.trim() || '{}');
      Object.keys(raw).forEach(function (key) {
        var lastPipe = key.lastIndexOf('|');
        var optionsKey = key.slice(0, lastPipe);
        var qty = parseFloat(key.slice(lastPipe + 1));
        if (!table[optionsKey]) table[optionsKey] = [];
        table[optionsKey].push([qty, raw[key]]);
      });
      Object.keys(table).forEach(function (optionsKey) {
        table[optionsKey].sort(function (a, b) { return a[0] - b[0]; });
      });
    } catch (e) {
      table = {};
    }
    return table;
  }

  currentOptionsKey() {
    if (this.optionSelectors.length === 0) return '';
    return this.optionSelectors.map(function (s) { return s.value; }).join(' / ') + ' / ';
  }

  rateCentsForQuantity(quantity) {
    var tiers = this.table[this.currentOptionsKey()];
    if (!tiers || tiers.length === 0) return 0;

    var applicable = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i][0] <= quantity) applicable = tiers[i];
    }
    return applicable[1] / applicable[0];
  }

  currentTotal() {
    var quantity = Number(this.quantityInput.value) || 0;
    var rate = this.rateCentsForQuantity(quantity);
    return (quantity * rate) / 100;
  }

  update() {
    var total = this.currentTotal();
    if (this.priceDisplay) this.priceDisplay.textContent = '$' + total.toFixed(2);
    if (this.priceNote) this.priceNote.hidden = true;

    if (this.priceSavings) {
      var quantity = Number(this.quantityInput.value) || 0;
      var tiers = this.table[this.currentOptionsKey()];
      var nextTier = null;
      if (tiers) {
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i][0] > quantity) { nextTier = tiers[i]; break; }
        }
      }

      if (nextTier) {
        var currentRate = this.rateCentsForQuantity(quantity);
        var nextRate = nextTier[1] / nextTier[0];
        var savingsPct = Math.round(((currentRate - nextRate) / currentRate) * 100);
        if (savingsPct > 0) {
          this.priceSavings.textContent = 'Order ' + nextTier[0] + ' to save ' + savingsPct + '% per ' + this.unitLabel + ' ($' + (nextRate / 100).toFixed(2) + ' vs $' + (currentRate / 100).toFixed(2) + ')';
          this.priceSavings.hidden = false;
        } else {
          this.priceSavings.hidden = true;
        }
      } else {
        this.priceSavings.hidden = true;
      }
    }
  }

  submitTierOrder(form, submitButton, originalLabel, rushCheckbox, rushFeeVariantId) {
    submitButton.disabled = true;
    submitButton.textContent = 'Adding…';

    var quantity = Number(this.quantityInput.value) || 0;
    var total = this.currentTotal();
    var dollars = Math.ceil(total);
    var optionsLabel = this.currentOptionsKey().replace(/\s*\/\s*$/, '');

    var formData = new FormData();
    formData.append('id', this.orderVariantId);
    formData.append('quantity', dollars);
    formData.append('properties[Product]', this.productTitle);
    formData.append('properties[_product_url]', window.location.pathname);
    if (optionsLabel) formData.append('properties[Options]', optionsLabel);
    formData.append('properties[Quantity]', quantity);
    formData.append('properties[Calculated Price]', '$' + dollars.toFixed(2));

    var artworkInput = form.querySelector('#ArtworkUpload');
    if (artworkInput && artworkInput.files[0]) {
      formData.append('properties[Artwork]', artworkInput.files[0]);
    }
    if (rushCheckbox && rushCheckbox.checked) {
      formData.append('properties[Rush Order]', 'Yes');
    }

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
          alert(data.description || 'Something went wrong adding this to your cart.');
          return Promise.reject(data);
        }
        if (rushCheckbox && rushCheckbox.checked && rushFeeVariantId) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: rushFeeVariantId, quantity: 1 })
          });
        }
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = displayCartCount(cart);
        });
        refreshCartDrawer();
        document.getElementById('cart-drawer').hidden = false;
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
      })
      .catch(function () {
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
      });
  }
}

customElements.define('quantity-tier-picker', QuantityTierPicker);

class StickerOutlineApproval extends HTMLElement {
  connectedCallback() {
    this.heading = this.querySelector('[data-outline-heading]');
    this.stage = this.querySelector('[data-outline-stage]');
    this.img = this.querySelector('[data-outline-img]');
    this.svg = this.querySelector('[data-outline-svg]');
    this.approveBtn = this.querySelector('[data-outline-approve]');
    this.manualBtn = this.querySelector('[data-outline-manual]');
    this.status = this.querySelector('[data-outline-status]');
    this.flagInput = this.querySelector('[data-outline-flag]');

    this.approvedMessage = this.dataset.approvedMessage || 'Outline approved.';
    this.manualMessage = this.dataset.manualMessage || 'Manual proof requested.';
    this.unsupportedMessage = this.dataset.unsupportedMessage || 'Preview unavailable for this file type.';

    if (this.heading) this.heading.textContent = this.dataset.heading || '';
    if (this.approveBtn) this.approveBtn.textContent = this.dataset.approveLabel || 'Approve this outline';
    if (this.manualBtn) this.manualBtn.textContent = this.dataset.manualLabel || 'Request a manual proof instead';

    var artworkId = this.dataset.artworkInput;
    this.artworkInput = artworkId ? document.getElementById(artworkId) : null;

    var form = this.closest('form');

    var shapeInputId = this.dataset.shapeInput;
    this.shapeInput = shapeInputId ? document.getElementById(shapeInputId) : null;
    if (this.dataset.shapeSelectorName && form) {
      this.shapeInput = form.querySelector('[data-option-name="' + this.dataset.shapeSelectorName + '"]');
    }

    this.widthInput = this.dataset.widthInput ? document.getElementById(this.dataset.widthInput) : null;
    this.heightInput = this.dataset.heightInput ? document.getElementById(this.dataset.heightInput) : null;
    this.sizeInput = null;
    if (this.dataset.sizeSelectorName && form) {
      this.sizeInput = form.querySelector('[data-option-name="' + this.dataset.sizeSelectorName + '"]');
    }

    var container = form || this.closest('custom-calculator') || document;
    this.submitButton = this.dataset.submitSelector ? container.querySelector(this.dataset.submitSelector) : null;

    if (this.artworkInput) this.artworkInput.addEventListener('change', this.handleArtworkChange.bind(this));
    if (this.shapeInput) {
      this.shapeInput.addEventListener('change', this.refreshVisibility.bind(this));
      this.shapeInput.addEventListener('input', this.refreshVisibility.bind(this));
    }
    if (this.approveBtn) this.approveBtn.addEventListener('click', this.approve.bind(this));
    if (this.manualBtn) this.manualBtn.addEventListener('click', this.requestManual.bind(this));

    this.refreshVisibility();
  }

  isCustomShape() {
    if (this.dataset.forceCustom === 'true') return true;
    var value = ((this.shapeInput && this.shapeInput.value) || '').toLowerCase();
    return value.indexOf('custom') > -1;
  }

  refreshVisibility() {
    var hasFile = this.artworkInput && this.artworkInput.files && this.artworkInput.files[0];
    if (this.isCustomShape() && hasFile) {
      this.hidden = false;
    } else {
      this.hidden = true;
      this.setSubmitEnabled(true);
    }
  }

  setSubmitEnabled(enabled) {
    if (this.submitButton) this.submitButton.disabled = !enabled;
  }

  resetDecision() {
    if (this.flagInput) this.flagInput.value = '';
    if (this.status) this.status.hidden = true;
    if (this.approveBtn) this.approveBtn.hidden = false;
    if (this.manualBtn) this.manualBtn.hidden = false;
    this.setSubmitEnabled(false);
  }

  handleArtworkChange() {
    this.refreshVisibility();
    var file = this.artworkInput.files && this.artworkInput.files[0];
    if (!file || !this.isCustomShape()) return;

    if (!file.type || file.type.indexOf('image/') !== 0) {
      if (this.img) this.img.hidden = true;
      if (this.svg) this.svg.hidden = true;
      this.resetDecision();
      if (this.approveBtn) this.approveBtn.hidden = true;
      if (this.status) {
        this.status.hidden = false;
        this.status.textContent = this.unsupportedMessage;
      }
      return;
    }

    var reader = new FileReader();
    reader.onload = function (e) {
      var image = new Image();
      image.onload = function () {
        this.traceAndRender(image);
      }.bind(this);
      image.src = e.target.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }

  pixelsPerMM(w, h) {
    var widthIn = null;
    if (this.widthInput && this.heightInput) {
      widthIn = Number(this.widthInput.value) || null;
    } else if (this.sizeInput && this.sizeInput.value) {
      var match = this.sizeInput.value.match(/(\d+(\.\d+)?)/);
      if (match) widthIn = Number(match[1]);
    }
    if (!widthIn) widthIn = 3;
    var widthMM = widthIn * 25.4;
    return Math.max(w, h) / widthMM;
  }

  traceAndRender(image) {
    this.resetDecision();

    var maxDim = 460;
    var scale = Math.min(1, maxDim / Math.max(image.naturalWidth, image.naturalHeight));
    var w = Math.max(1, Math.round(image.naturalWidth * scale));
    var h = Math.max(1, Math.round(image.naturalHeight * scale));

    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0, w, h);

    var imageData;
    try {
      imageData = ctx.getImageData(0, 0, w, h);
    } catch (e) {
      if (this.img) {
        this.img.src = image.src;
        this.img.hidden = false;
      }
      return;
    }

    try {
      var mask = this.buildMask(imageData, w, h);

      var distField = this.chamferDistance(mask, w, h);
      var pxPerMM = this.pixelsPerMM(w, h);
      var borderPx = Math.max(1, pxPerMM * 2);

      var negField = new Float32Array(w * h);
      for (var ni = 0; ni < w * h; ni++) negField[ni] = -distField[ni];

      var segments = this.marchingSquares(negField, w, h, -borderPx);
      var loops = this.stitchSegments(segments);

      if (loops.length === 0) {
        throw new Error('no contour found');
      }

      var largest = loops[0];
      var largestArea = Math.abs(this.polygonArea(largest));
      for (var li = 1; li < loops.length; li++) {
        var a = Math.abs(this.polygonArea(loops[li]));
        if (a > largestArea) { largestArea = a; largest = loops[li]; }
      }

      var cleaned = this.clampRadialOutliers(largest, 1.7);
      var step0 = Math.max(1, Math.floor(cleaned.length / 240));
      var decimated = [];
      for (var di = 0; di < cleaned.length; di += step0) decimated.push(cleaned[di]);
      var offsetLoop = this.chaikinSmooth(decimated, 2);

      if (!offsetLoop || offsetLoop.length < 3) {
        throw new Error('offset loop too small');
      }

      var compositeCanvas = document.createElement('canvas');
      compositeCanvas.width = w;
      compositeCanvas.height = h;
      var cctx = compositeCanvas.getContext('2d');
      var path2d = new Path2D();
      path2d.moveTo(offsetLoop[0][0], offsetLoop[0][1]);
      for (var pi = 1; pi < offsetLoop.length; pi++) path2d.lineTo(offsetLoop[pi][0], offsetLoop[pi][1]);
      path2d.closePath();
      cctx.fillStyle = '#ffffff';
      cctx.fill(path2d);
      cctx.drawImage(image, 0, 0, w, h);

      if (this.img) {
        this.img.src = compositeCanvas.toDataURL();
        this.img.hidden = false;
        this.img.style.width = w + 'px';
        this.img.style.height = h + 'px';
      }

      var step = Math.max(1, Math.floor(offsetLoop.length / 260));
      var simplified = [];
      for (var si = 0; si < offsetLoop.length; si += step) simplified.push(offsetLoop[si]);

      var d = 'M ' + simplified[0][0].toFixed(1) + ' ' + simplified[0][1].toFixed(1);
      for (var j = 1; j < simplified.length; j++) {
        d += ' L ' + simplified[j][0].toFixed(1) + ' ' + simplified[j][1].toFixed(1);
      }
      d += ' Z';

      if (this.svg) {
        this.svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        this.svg.style.width = w + 'px';
        this.svg.style.height = h + 'px';
        this.svg.innerHTML =
          '<path d="' + d + '" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linejoin="round" stroke-linecap="round" />' +
          '<path d="' + d + '" fill="none" stroke="#1a1a1a" stroke-width="1" stroke-dasharray="4 3" stroke-linejoin="round" stroke-linecap="round" />';
        this.svg.hidden = false;
      }
    } catch (traceError) {
      if (this.img) {
        this.img.src = image.src;
        this.img.hidden = false;
        this.img.style.width = w + 'px';
        this.img.style.height = h + 'px';
      }
      if (this.svg) this.svg.hidden = true;
    }
  }

  chamferDistance(mask, w, h) {
    var INF = 1e9;
    var dist = new Float32Array(w * h);
    var DIAG = 1.41421356;
    for (var p = 0; p < w * h; p++) dist[p] = mask[p] ? 0 : INF;

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var idx = y * w + x;
        if (mask[idx]) continue;
        var best = dist[idx];
        if (x > 0) best = Math.min(best, dist[idx - 1] + 1);
        if (y > 0) best = Math.min(best, dist[idx - w] + 1);
        if (x > 0 && y > 0) best = Math.min(best, dist[idx - w - 1] + DIAG);
        if (x < w - 1 && y > 0) best = Math.min(best, dist[idx - w + 1] + DIAG);
        dist[idx] = best;
      }
    }

    for (var y2 = h - 1; y2 >= 0; y2--) {
      for (var x2 = w - 1; x2 >= 0; x2--) {
        var idx2 = y2 * w + x2;
        if (mask[idx2]) continue;
        var best2 = dist[idx2];
        if (x2 < w - 1) best2 = Math.min(best2, dist[idx2 + 1] + 1);
        if (y2 < h - 1) best2 = Math.min(best2, dist[idx2 + w] + 1);
        if (x2 < w - 1 && y2 < h - 1) best2 = Math.min(best2, dist[idx2 + w + 1] + DIAG);
        if (x2 > 0 && y2 < h - 1) best2 = Math.min(best2, dist[idx2 + w - 1] + DIAG);
        dist[idx2] = best2;
      }
    }

    return dist;
  }

  buildMask(imageData, w, h) {
    var data = imageData.data;
    var mask = new Uint8Array(w * h);
    var hasAlpha = false;
    for (var i = 3; i < data.length; i += 4) {
      if (data[i] < 250) { hasAlpha = true; break; }
    }

    if (hasAlpha) {
      for (var p = 0; p < w * h; p++) mask[p] = data[p * 4 + 3] > 25 ? 1 : 0;
      return mask;
    }

    var bg = this.regionGrowBackground(data, w, h, 26);
    for (var q = 0; q < w * h; q++) mask[q] = bg[q] ? 0 : 1;
    return mask;
  }

  regionGrowBackground(data, w, h, tolerance) {
    var n = w * h;
    var bgMask = new Uint8Array(n);
    var visited = new Uint8Array(n);
    var queue = [];

    function colorAt(idx) { return [data[idx * 4], data[idx * 4 + 1], data[idx * 4 + 2]]; }
    function seed(idx) {
      if (!visited[idx]) { visited[idx] = 1; bgMask[idx] = 1; queue.push(idx); }
    }

    for (var x = 0; x < w; x++) {
      seed(x);
      seed((h - 1) * w + x);
    }
    for (var y = 0; y < h; y++) {
      seed(y * w);
      seed(y * w + (w - 1));
    }

    while (queue.length) {
      var idx = queue.pop();
      var cx = idx % w, cy = (idx - cx) / w;
      var c0 = colorAt(idx);
      var neighbors = [[cx - 1, cy], [cx + 1, cy], [cx, cy - 1], [cx, cy + 1]];
      for (var k = 0; k < 4; k++) {
        var nx = neighbors[k][0], ny = neighbors[k][1];
        if (nx < 0 || nx >= w || ny < 0 || ny >= h) continue;
        var nIdx = ny * w + nx;
        if (visited[nIdx]) continue;
        var c1 = colorAt(nIdx);
        var dist = Math.sqrt(Math.pow(c0[0] - c1[0], 2) + Math.pow(c0[1] - c1[1], 2) + Math.pow(c0[2] - c1[2], 2));
        visited[nIdx] = 1;
        if (dist <= tolerance) {
          bgMask[nIdx] = 1;
          queue.push(nIdx);
        }
      }
    }
    return bgMask;
  }

  marchingSquares(field, w, h, threshold) {
    var segments = [];
    function interp(v0, v1, p0, p1) {
      if (v1 === v0) return p0;
      var t = (threshold - v0) / (v1 - v0);
      return p0 + t * (p1 - p0);
    }

    for (var y = 0; y < h - 1; y++) {
      for (var x = 0; x < w - 1; x++) {
        var tl = field[y * w + x];
        var tr = field[y * w + x + 1];
        var bl = field[(y + 1) * w + x];
        var br = field[(y + 1) * w + x + 1];

        var caseIdx = (tl >= threshold ? 1 : 0) | (tr >= threshold ? 2 : 0) | (br >= threshold ? 4 : 0) | (bl >= threshold ? 8 : 0);
        if (caseIdx === 0 || caseIdx === 15) continue;

        var top = [x + interp(tl, tr, 0, 1), y];
        var right = [x + 1, y + interp(tr, br, 0, 1)];
        var bottom = [x + interp(bl, br, 0, 1), y + 1];
        var left = [x, y + interp(tl, bl, 0, 1)];
        var center = (tl + tr + bl + br) / 4;

        switch (caseIdx) {
          case 1: case 14: segments.push([left, top]); break;
          case 2: case 13: segments.push([top, right]); break;
          case 3: case 12: segments.push([left, right]); break;
          case 4: case 11: segments.push([right, bottom]); break;
          case 6: case 9: segments.push([top, bottom]); break;
          case 7: case 8: segments.push([left, bottom]); break;
          case 5:
            if (center >= threshold) { segments.push([left, top]); segments.push([right, bottom]); }
            else { segments.push([left, bottom]); segments.push([top, right]); }
            break;
          case 10:
            if (center >= threshold) { segments.push([top, right]); segments.push([left, bottom]); }
            else { segments.push([top, left]); segments.push([right, bottom]); }
            break;
        }
      }
    }
    return segments;
  }

  stitchSegments(segments) {
    function keyOf(p) { return p[0].toFixed(2) + ',' + p[1].toFixed(2); }
    function edgeKey(a, b) { return a < b ? a + '|' + b : b + '|' + a; }

    var adjacency = {};
    var pointByKey = {};
    segments.forEach(function (seg) {
      var k0 = keyOf(seg[0]), k1 = keyOf(seg[1]);
      pointByKey[k0] = seg[0];
      pointByKey[k1] = seg[1];
      if (!adjacency[k0]) adjacency[k0] = [];
      if (!adjacency[k1]) adjacency[k1] = [];
      adjacency[k0].push(k1);
      adjacency[k1].push(k0);
    });

    var visitedEdges = {};
    var loops = [];

    Object.keys(adjacency).forEach(function (startKey) {
      var neighbors = adjacency[startKey];
      for (var ni = 0; ni < neighbors.length; ni++) {
        var firstNeighbor = neighbors[ni];
        var ek = edgeKey(startKey, firstNeighbor);
        if (visitedEdges[ek]) continue;

        var loopKeys = [startKey];
        visitedEdges[ek] = true;
        var currentKey = firstNeighbor;
        var guard = 0;

        while (currentKey !== startKey && guard < 100000) {
          loopKeys.push(currentKey);
          var options = adjacency[currentKey] || [];
          var nextKey = null;
          for (var oi = 0; oi < options.length; oi++) {
            var candEdge = edgeKey(currentKey, options[oi]);
            if (!visitedEdges[candEdge]) { nextKey = options[oi]; break; }
          }
          if (nextKey === null) break;
          visitedEdges[edgeKey(currentKey, nextKey)] = true;
          currentKey = nextKey;
          guard++;
        }

        if (currentKey === startKey && loopKeys.length > 3) {
          loops.push(loopKeys.map(function (k) { return pointByKey[k]; }));
        }
      }
    });

    return loops;
  }

  polygonArea(points) {
    var area = 0;
    var n = points.length;
    for (var i = 0; i < n; i++) {
      var p1 = points[i], p2 = points[(i + 1) % n];
      area += p1[0] * p2[1] - p2[0] * p1[1];
    }
    return area / 2;
  }

  clampRadialOutliers(points, factor) {
    var n = points.length;
    if (n < 5) return points;
    var cx = 0, cy = 0;
    for (var i = 0; i < n; i++) { cx += points[i][0]; cy += points[i][1]; }
    cx /= n; cy /= n;

    var dists = points.map(function (p) {
      return Math.sqrt(Math.pow(p[0] - cx, 2) + Math.pow(p[1] - cy, 2));
    });
    var sorted = dists.slice().sort(function (a, b) { return a - b; });
    var median = sorted[Math.floor(sorted.length / 2)] || 1;
    var maxAllowed = median * factor;

    return points.map(function (p, idx) {
      var d = dists[idx];
      if (d <= maxAllowed || d === 0) return p;
      var scale = maxAllowed / d;
      return [cx + (p[0] - cx) * scale, cy + (p[1] - cy) * scale];
    });
  }

  chaikinSmooth(points, iterations) {
    var current = points;
    for (var iter = 0; iter < iterations; iter++) {
      var n = current.length;
      if (n < 3) return current;
      var next = [];
      for (var i = 0; i < n; i++) {
        var p0 = current[i];
        var p1 = current[(i + 1) % n];
        next.push([0.75 * p0[0] + 0.25 * p1[0], 0.75 * p0[1] + 0.25 * p1[1]]);
        next.push([0.25 * p0[0] + 0.75 * p1[0], 0.25 * p0[1] + 0.75 * p1[1]]);
      }
      current = next;
    }
    return current;
  }


  approve() {
    if (this.flagInput) this.flagInput.value = 'Customer Approved Outline';
    if (this.status) {
      this.status.textContent = this.approvedMessage;
      this.status.hidden = false;
    }
    if (this.approveBtn) this.approveBtn.hidden = true;
    if (this.manualBtn) this.manualBtn.hidden = true;
    this.setSubmitEnabled(true);
  }

  requestManual() {
    if (this.flagInput) this.flagInput.value = 'Manual Proof Requested';
    if (this.status) {
      this.status.textContent = this.manualMessage;
      this.status.hidden = false;
    }
    if (this.approveBtn) this.approveBtn.hidden = true;
    if (this.manualBtn) this.manualBtn.hidden = true;
    this.setSubmitEnabled(true);
  }
}

customElements.define('sticker-outline-approval', StickerOutlineApproval);
